import Crud from '../views/ProfessionalType/Crud'
import Entity from '../views/ProfessionalType/Add'

let routes = {
    path: '/professional_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/professional_types/add',
            name: 'NewProfessionalType',
            component: Entity,
            meta: {
                pageTitle: 'professionalType.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'professionalType.form.titleNew',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/professional_types/edit/:id?',
            name: 'EditProfessionalType',
            component: Entity,
            meta: {
                pageTitle: 'professionalType.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'professionalType.form.titleEdit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/professional_types',
            name: 'list-professional-types',
            component: Crud,
            meta: {
                pageTitle: 'professionalType.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'professionalType.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
